export function getFieldConfig(templateConfig){
  let fieldConfig = {};
  let dynamicConfig = [];
  let offerDynamicConfig = [];
  let matFields = [
    {
      code:'Q',
      fieldStr:'data.sourceMaterialDt.demandQuantity'
    },{
      code:'T',
      fieldStr:'data.taxRate'
    }
  ];
  if(templateConfig && templateConfig.dynamicForm && templateConfig.dynamicForm.dynamicTables){
    templateConfig.dynamicForm.dynamicTables.forEach((item) => {
      if(item.dataType === 'Multiple'){
        item.sortNumber = item.orderNumber;
        if(item.tabsCode === 'inquiry'){
          dynamicConfig.push(item);
        }else if(item.tabsCode === 'offer'){
          offerDynamicConfig.push(item);
        }
      }else if(item.code === 'inquiry_table'){
        if(item.dynamicFields){
          item.dynamicFields.forEach((item2) => {
            item2.sortNumber = item2.fieldOrder;
            item2.tableName = item.tableName;
            dynamicConfig.push(item2);
            matFields.push({
              code:item2.englishName,
              fieldStr:`Number(data.sourceMaterialDt.dynamicValueJsonObj.data.${item2.tableName}.${item2.fieldName})`
            })
          })
        }
      }else if(item.code === 'offer_table'){
        item.dynamicFields.forEach((item2) => {
          item2.sortNumber = item2.fieldOrder;
          item2.tableName = item.tableName;
          offerDynamicConfig.push(item2);
          matFields.push({
            code:item2.englishName,
            fieldStr:`Number(data.dynamicValueJsonObj.data.${item2.tableName}.${item2.fieldName})`
          })
        })
      }
    });
    if(dynamicConfig && dynamicConfig.length){
      fieldConfig.inquiryFieldList = dynamicConfig.sort((item1,item2) => {
        if(!(item1.sortNumber || item1.sortNumber === 0)){
          return 1;
        }
        if(!(item2.sortNumber || item2.sortNumber === 0)){
          return -1;
        }
        return item1.sortNumber - item2.sortNumber;
      })
    }else{
      fieldConfig.inquiryFieldList = [];
    }
    if(offerDynamicConfig && offerDynamicConfig.length){
      fieldConfig.offerFieldList = offerDynamicConfig.sort((item1,item2) => {
        if(!(item1.sortNumber || item1.sortNumber === 0)){
          return 1;
        }
        if(!(item2.sortNumber || item2.sortNumber === 0)){
          return -1;
        }
        return item1.sortNumber - item2.sortNumber;
      })
    }else{
      fieldConfig.offerFieldList = [];
    }
  }
  //报价字段、询价字段中需要计算的字段进行排序
  let calcPriceList = []; //报价计算字段
  let inqCalcPriceList = []; //询价计算字段
  let calcList = []; //报价计算字段（排序）
  let inqCalcList = []; // 询价计算字段（排序）
  let calcFields = ['Q','T']; // 已排序的报价计算字段code
  let inqCalcFields = ['Q','T']; //已排序的询价计算字段code
  if(fieldConfig.offerFieldList){
    calcPriceList = fieldConfig.offerFieldList.filter((item) => {
      if(!item.inputRegEx){
        calcFields.push(item.englishName);
        inqCalcFields.push(item.englishName);
      }
      return item.inputRegEx;
    });
  }
  if(fieldConfig.inquiryFieldList){
    inqCalcPriceList = fieldConfig.inquiryFieldList.filter((item) => {
      if(!item.inputRegEx){
        calcFields.push(item.englishName);
        inqCalcFields.push(item.englishName);
      }
      return item.inputRegEx;
    })
  }
  while (calcList.length < calcPriceList.length){
    console.log('报价计算字段排序');
    let breakBol = false;
    calcPriceList.forEach((item) => {
      if(item.inputRegEx){
        const fieldList = item.inputRegEx.replace(/[+*\-\/]/g,'|').replace(/[\(\)]/g,'').split('|');
        let bol = fieldList.every((cField) => {
          if(cField.indexOf('SUM') > -1){
            return true;
          }
          let regPos = /^\d+(\.\d+)?$/;
          let regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/;
          if(regPos.test(cField) || regNeg.test(cField)) {
            return true;
          } else {
            return calcFields.indexOf(cField) > -1;
          }
        });
        if(bol){
          if(calcFields.indexOf(item.englishName) === -1){
            calcList.push(item);
            calcFields.push(item.englishName);
            breakBol = true;
          }
        }
      }
    });
    if(!breakBol){
      calcList = calcPriceList;
      break;
    }
  }
  while (inqCalcList.length < inqCalcPriceList.length){
    console.log('询价计算字段排序');
    let inqBreakBol = false;
    inqCalcPriceList.forEach((item) => {
      if(item.inputRegEx){
        const fieldList = item.inputRegEx.replace(/[+*\-\/]/g,'|').replace(/[\(\)]/g,'').split('|');
        let bol = fieldList.every((cField) => {
          if(cField.indexOf('SUM') > -1){
            return true;
          }
          let regPos = /^\d+(\.\d+)?$/;
          let regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/;
          if(regPos.test(cField) || regNeg.test(cField)) {
            return true;
          } else {
            return inqCalcFields.indexOf(cField) > -1;
          }
        });
        if(bol){
          if(inqCalcFields.indexOf(item.englishName) === -1){
            inqCalcList.push(item);
            inqCalcFields.push(item.englishName);
            inqBreakBol = true;
          }
        }
      }
    });
    if(!inqBreakBol){
      inqCalcList = inqCalcPriceList;
      break;
    }
  }
  calcPriceList = calcList;
  inqCalcPriceList = inqCalcList;
  //用变量替代公式中的code;
  const beforeValidStr = '+-*/(';
  const afterValidStr = '+-*/)';
  matFields.forEach((field) => {
    for(let k = 0;k < calcPriceList.length;k++){
      let index = 0;
      let str = calcPriceList[k].inputRegEx;
      let key = field.code;
      let replaceStr = '';
      for(let o=0;o<key.length;o++){
        replaceStr += '?';
      }
      while ((index = str.indexOf(key, index)) != -1){
        if((index === 0 || beforeValidStr.indexOf(str[index-1]) > -1) && ((index + key.length) === str.length || afterValidStr.indexOf(str[index + key.length]) > -1)){
          str = str.substring(0, index) + replaceStr + str.substring(index + key.length);
        }
        index += key.length;
      }
      let list = str.split(replaceStr);
      str = list.join(`(${field.fieldStr})`);
      calcPriceList[k].inputRegEx = str;
    }
    for(let k = 0;k < inqCalcPriceList.length;k++){
      let index = 0;
      let str = inqCalcPriceList[k].inputRegEx;
      let key = field.code;
      let replaceStr = '';
      for(let o=0;o<key.length;o++){
        replaceStr += '?';
      }
      while ((index = str.indexOf(key, index)) != -1){
        if((index === 0 || beforeValidStr.indexOf(str[index-1]) > -1) && ((index + key.length) === str.length || afterValidStr.indexOf(str[index + key.length]) > -1)){
          str = str.substring(0, index) + replaceStr + str.substring(index + key.length);
        }
        index += key.length;
      }
      let list = str.split(replaceStr);
      str = list.join(`(${field.fieldStr})`);
      str = str.split('data.sourceMaterialDt.dynamicValueJsonObj').join('data.dynamicValueJsonObj');
      inqCalcPriceList[k].inputRegEx = str;
    }
  });
  fieldConfig.calcPriceList = calcPriceList;
  fieldConfig.inqCalcPriceList = inqCalcPriceList;
  return fieldConfig;
}



// WEBPACK FOOTER //
// ./src/page/sources/source.js